module.exports = "<p-toast [style]=\"{marginTop: '80px'}\" position=\"top-center\"></p-toast>\n<router-outlet></router-outlet>\n"